import styles from './style.module.scss';
import { useState } from 'react';
import { Element } from 'react-scroll';
import CurShowCard from '../../commonComponents/curShowCard';
import CurShowTab from '../../commonComponents/curShowTab';
import FeatureExperienced from '/components/productPageComponents/featureExperience';
import MobileTab from '/components/solutionPageComponent/mobileTab';

const ProjectScenarios = ({ elementName, scenariosData }) => {
  const [currentDisplay, setCurrentDisplay] = useState(0);
  const { title, items } = scenariosData;
  return (
    <Element name={elementName}>
      <main className={styles['wrapper']}>
        <section className={styles['title']}>{title}</section>
        <section className={styles['content-header']}>
          <div className={styles['item-wrapper']}>
            {items.map((item, index) => (
              <CurShowTab
                key={index}
                item={item}
                activeIndex={currentDisplay}
                itemIndex={index}
                onTabChange={() => {
                  setCurrentDisplay(index);
                }}
              />
            ))}
          </div>
          <div className={styles['oneline']}></div>
        </section>

        {/* 展示区 */}
        <section className={styles['content-show']}>
          {items.map((item, index) => (
            <CurShowCard
              item={item}
              isCurPlay={index === currentDisplay}
              key={index}
            />
          ))}
        </section>
      </main>
      <main className={styles['wrapper-mobile']}>
        <MobileTab useCaseData={scenariosData} />
      </main>
    </Element>
  );
};

export default ProjectScenarios;
